import { render, staticRenderFns } from "./post-single.vue?vue&type=template&id=5fd798fc&lang=pug&"
import script from "./post-single.vue?vue&type=script&lang=js&"
export * from "./post-single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports